import TableHeader from "./TableHeader/TableHeader"
import TableItem from "./TableItem/TableItem"
import useStyle from "./useStyle"

function Table({ rows, setLoading, orderDesc }) {
  const classes = useStyle()
  return (
    <div className={classes.root}>
      <div className={classes.tableWrap}>
        {rows && rows.length > 0 ? (
          <table className={classes.table}>
            <TableHeader orderDesc={orderDesc} rows={rows} />
            <tbody className={classes.tableBody}>
              {rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={index}
                  item={item}
                  setLoading={setLoading}
                />
              ))}
            </tbody>
          </table>
        ) : (
          <div className={classes.titleEmpty}>
            No existen modificaciones del estado
          </div>
        )}
      </div>
    </div>
  )
}

export default Table
